<!-- DESKTOP -->
<div
  *ngIf="(platformService.isTouchExperience$ | async) === false"
  id="desktop"
>
  <!-- Product Card Info -->
  <div class="usf-product-card-info">
    <!-- Product Card Thumbnail -->
    <span class="usf-product-card-img">
      <img
        data-cy="usf-product-card-desktop-img"
        src="{{ thumbnailImageURL }}"
        (error)="
          this.thumbnailImageURL = getAlternativeThumbnail(thumbnailImageURL)
        "
        *ngIf="(panAppState.online$ | async) === true && !!thumbnailImageURL"
      />
      <ion-icon
        name="restaurant"
        data-cy="usf-product-card-desktop-icon"
        *ngIf="(panAppState.online$ | async) === false || !thumbnailImageURL"
        class="no-image"
      ></ion-icon>
    </span>

    <!-- Product Card Brand, Description, Number, Sales Pack Price, Note -->
    <div class="usf-product-card-desc">
      <div
        class="usf-product-card-brand-txt"
        data-cy="usf-product-card-desktop-brand-text"
      >
        #{{ product?.productNumber || ' ' }}&nbsp;&nbsp;|&nbsp;&nbsp;{{
          product?.summary?.brand || ' ' | acronymTitleCase
        }}
      </div>
      <span
        class="usf-product-card-desc-heading-txt"
        data-cy="usf-product-card-desktop-heading-text"
      >
        {{ (product?.summary?.productDescTxtl | acronymTitleCase) || ' ' }}
      </span>

      <!-- Original Product Tags -->
      <div
        class="usf-product-card-tags"
        data-cy="usf-product-card-desktop-tags"
        *ngIf="productTags?.length"
      >
        <app-usf-product-tag-list
          [tagList]="productTags?.slice(0, 5)"
          [infoIconEnabled]="false"
          [product]="product"
        >
        </app-usf-product-tag-list>
        <span *ngIf="productTags?.length > 5">
          {{ '+' + (productTags?.length - 5) }}
        </span>
      </div>
    </div>
  </div>
</div>

<!-- TOUCH -->
<div *ngIf="(platformService.isTouchExperience$ | async) === true" id="touch">
  <!-- Product Card Info -->
  <div class="usf-product-card-info">
    <!-- Product Card Thumbnail -->
    <span class="usf-product-card-img">
      <img
        data-cy="usf-product-card-touch-img"
        src="{{ thumbnailImageURL }}"
        (error)="
          this.thumbnailImageURL = getAlternativeThumbnail(thumbnailImageURL)
        "
        *ngIf="(panAppState.online$ | async) === true && !!thumbnailImageURL"
      />
      <ion-icon
        name="restaurant"
        data-cy="usf-product-card-touch-icon"
        *ngIf="(panAppState.online$ | async) === false || !thumbnailImageURL"
        class="no-image"
      ></ion-icon>
    </span>

    <!-- Product Card Brand, Description, Number, Sales Pack Price, Note -->
    <div class="usf-product-card-desc">
      <div
        class="usf-product-card-brand-txt"
        data-cy="usf-product-card-touch-brand-text"
      >
        <span>#{{ product?.productNumber || ' ' }}</span> |
        <span>{{ product?.summary?.brand || ' ' | acronymTitleCase }}</span>
      </div>
      <span
        class="usf-product-card-desc-heading-txt"
        data-cy="usf-product-card-touch-heading-text"
      >
        {{ (product?.summary?.productDescTxtl | acronymTitleCase) || ' ' }}
      </span>

      <!-- Original Product Tags -->
      <div
        class="usf-product-card-tags"
        data-cy="usf-product-card-touch-tablet-tags"
        *ngIf="productTags?.length && platformType === platformEnum.tablet"
      >
        <app-usf-product-tag-list
          [tagList]="productTags?.slice(0, 5)"
          [infoIconEnabled]="false"
          [product]="product"
        >
        </app-usf-product-tag-list>
        <span *ngIf="productTags?.length > 5">
          {{ '+' + (productTags?.length - 5) }}
        </span>
      </div>
    </div>
  </div>
  <!-- Original Product Tags -->
  <section
    class="product-tag-section"
    *ngIf="productTags?.length && platformType === platformEnum.mobile"
  >
    <div
      class="usf-product-card-tags"
      data-cy="usf-original-product-card-touch-mobile-tags"
    >
      <app-usf-product-tag-list
        [tagList]="productTags?.slice(0, 3)"
        [infoIconEnabled]="false"
      >
      </app-usf-product-tag-list>
      <span *ngIf="productTags?.length > 3">
        {{ '+' + (productTags?.length - 3) }}
      </span>
    </div>
  </section>
</div>
